import { AxiosRequestConfig } from 'axios';
import { ChangePassApiData, ResetLinkFormData, ResetPassApiData } from 'features/forgotPass/interface/password';
import { currentLanguage } from 'shared/constants/common';
import { findCookieValue } from 'shared/util/utility';

const PasswordApiWrapper = (requests: any) => {
	return {
		forgotPassword: (fieldConfig: ResetLinkFormData) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.post(`/customer/account/reset-password`, fieldConfig, config);
		},
		resetPassword: (fieldConfig: ResetPassApiData) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.post(`/customer/account/reset-password-verify`, fieldConfig, config);
		},
		changePassword: (fieldConfig: ChangePassApiData) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.post(`/customer/account/change-password`, fieldConfig, config);
		},
	};
};

export default PasswordApiWrapper;
